import {
  AppstoreOutlined,
  CameraOutlined,
  GoldOutlined,
  HomeOutlined,
  LogoutOutlined,
  SettingOutlined,
  SketchOutlined
} from '@ant-design/icons';
import { App, Badge, Button, Col, FloatButton, Image, Layout, Menu, Row, Tag, theme, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import {
  NavLink,
  Outlet,
  useLocation
} from 'react-router-dom';
import config from '../../common/config/env';
import GenieDrawerComponent from '../features/openai/components/GenieDrawerComponent';
import {FaMagic} from "react-icons/fa";

const { Header, Sider, Content, Footer } = Layout;
const { Title } = Typography;

function KMSApp() {
  const [collapsed, setCollapsed] = useState(false);
  const [genieOpen, setGenieOpen] = useState(false);
  const [defaultMenuKey, setDefaultMenuKey] = useState(
    MENU_PATH_MAP.DASHBOARD.key
  );
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const location = useLocation();
  const getLocation = () => {
    return location.pathname;
  };

  useEffect(() => {
    const found = Object.entries(MENU_PATH_MAP).find(
      (e) => e[1].path === location.pathname
    );
    if (found) {
      setDefaultMenuKey(found[1].key);
    } else {
      setDefaultMenuKey(MENU_PATH_MAP.DASHBOARD.key);
    }
  });
 const onSignOut = async (e)=>{
  try{
    await Auth.signOut();
  }catch(error){
    console.error(error);
  }
 }

  return (
    <App>
      <Layout className="site-layout" style={{ minHeight: '100vh' }}>
        <Header
          style={{height:'auto', padding: 0, background: colorBgContainer }}
        >
          <Row style={{padding:'2px 0 2px 5px'}}>
            <Col span={10}>
              <Image 
                width={75}
                preview={false}
                src="https://truvana.s3.ap-southeast-2.amazonaws.com/assets/MasterSync-BlackRed.png"
              />
            </Col>
            <Col span={11}>
              <Title level={3}>MasterSync v{config.APP_VERSION}</Title>
              
            </Col>
            <Col span={2} >
            <Tag color={config.name==='Production'?'red':'green'}>{config.name}</Tag>
            </Col>
            <Col span={1} >
              <Button icon={<LogoutOutlined />} shape={'circle'} onClick={onSignOut} danger/>
            </Col>
          </Row>
          {/* {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: 'trigger',
                onClick: () => setCollapsed(!collapsed),
              }   $250000 from harma + $7000
            )} */}
        </Header>
        <Layout>
          <Sider trigger={null} collapsible collapsed={collapsed}>
            <div className="logo" />
            <Menu
              theme="dark"
              mode="inline"
              selectedKeys={defaultMenuKey}
              defaultSelectedKeys={MENU_PATH_MAP.DASHBOARD.key}
            >
              <Menu.Item
                key={MENU_PATH_MAP.DASHBOARD.key}
                icon={<HomeOutlined />}
              >
                <NavLink to={MENU_PATH_MAP.DASHBOARD.path}>
                  <span>{MENU_PATH_MAP.DASHBOARD.label}</span>
                </NavLink>
              </Menu.Item>
                <Menu.Item
                  key={MENU_PATH_MAP.PRODUCTS.key}
                  icon={<AppstoreOutlined />}
                >
                  <NavLink to={MENU_PATH_MAP.PRODUCTS.path}>
                    <span>{MENU_PATH_MAP.PRODUCTS.label}</span>
                  </NavLink>
                </Menu.Item>
              <Badge.Ribbon text="Coming Soon" placement="end" color="volcano">
                <Menu.Item
                  key={MENU_PATH_MAP.ORDERS.key}
                  icon={<GoldOutlined />}
                >
                  <NavLink to={MENU_PATH_MAP.ORDERS.path}>
                    <span>{MENU_PATH_MAP.ORDERS.label}</span>
                  </NavLink>
                </Menu.Item>
              </Badge.Ribbon>
              <Badge.Ribbon text="Coming Soon" placement="end" color="volcano">
                <Menu.Item
                  key={MENU_PATH_MAP.IMAGES.key}
                  icon={<CameraOutlined />}
                >
                  <NavLink to={MENU_PATH_MAP.IMAGES.path}>
                    <span>{MENU_PATH_MAP.IMAGES.label}</span>
                  </NavLink>
                </Menu.Item>
              </Badge.Ribbon>
              <Menu.Item
                key={MENU_PATH_MAP.SETTINGS.key}
                icon={<SettingOutlined />}
              >
                <NavLink to={MENU_PATH_MAP.SETTINGS.path}>
                  <span>{MENU_PATH_MAP.SETTINGS.label}</span>
                </NavLink>
              </Menu.Item>
            </Menu>
          </Sider>
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              background: colorBgContainer,
            }}
          >
            <Outlet />
            <FloatButton tooltip={<div>Open Genie</div>} icon={<FaMagic />} onClick={()=> setGenieOpen(!genieOpen)}/>
            <GenieDrawerComponent open={genieOpen} onClose={()=> setGenieOpen(false)}/>
          </Content>
        </Layout>
        {/* <Footer>Footer</Footer> */}
      </Layout>
    </App>
  );
}

export default KMSApp;

export const MENU_PATH_MAP = {
  DASHBOARD: {
    key: 'menu.key.dashboard',
    label: 'Dashboard',
    path: '/',
  },
  PRODUCTS: {
    key: 'menu.key.products',
    label: 'Products',
    path: '/products',
  },
  ORDERS: {
    key: 'menu.key.orders',
    label: 'Orders',
    path: '/orders',
  },
  IMAGES: {
    key: 'menu.key.images',
    label: 'Images',
    path: '/images',
  },
  SETTINGS: {
    key: 'menu.key.settings',
    label: 'Settings',
    path: '/settings',
  },
};
